import AudioSequencer from "./AudioSequencer";
import { GameHowl } from "./GameHowl";

export default abstract class SeamlessAudioSequencer extends AudioSequencer {
    public crossfade(current: GameHowl, next: GameHowl, fadeTimeInSeconds: number) {
        if (fadeTimeInSeconds == 0) {
            super.crossfade(current, next, 0);
            return;
        }
       
        this.sequence.tracks.forEach(track => {
            if (track != current) {
                track.stop();
            }
        });

        const bps = this.sequence.bpm / 60;
        const seekInSeconds = current.seek() as number % (bps * this.sequence.bpsMultiplier);

        current.fade(this.volume, 0, fadeTimeInSeconds * 1000);

        next.seek(seekInSeconds);
        next.play();
        next.fade(0, this.volumeOverride, fadeTimeInSeconds * 1000);
    }
}
